import { Component, OnInit } from '@angular/core';
import { CustomerReportingToastService } from '../../services/customer-reporting-toast.service';
@Component({
  selector: 'app-report-toast-container',
  template: `
    <div class="toast-container" *ngIf="toastService.toasts.length > 0">
      <app-toast
        *ngFor="let toast of toastService.toasts"
        [toast]="toast"
        (closeToast)="toastService.remove(toast)"
      ></app-toast>
    </div>
  `,
  styleUrls: ['./report-toast-container.component.scss'],
})
export class ReportToastContainerComponent implements OnInit {
  constructor(public toastService: CustomerReportingToastService) {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit() {}
}
